export default __webpack_public_path__ + "static/media/Samsung.f657d25f.png";